import React from 'react';
import PropTypes from 'prop-types';

const WeatherIcon = ({ iconUrl, ...rest }) => {
  return (
    <image
      x={rest.x}
      y={rest.y}
      width="41"
      height="41"
      href={`/siteicons/weathericons/svg/${iconUrl}.svg`}
      alt="weather icon"
    />
  );
};

WeatherIcon.propTypes = {
  iconUrl: PropTypes.string,
};

export default WeatherIcon;
